function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.242.213A.727.727 0 10.213 1.242L6.971 8 .213 14.758a.727.727 0 101.029 1.029L8 9.029l6.758 6.758a.727.727 0 001.029-1.029L9.029 8l6.758-6.758A.727.727 0 0014.758.213L8 6.971 1.242.213z",
  fill: "#00253E"
})));